module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"update-packaging":"Update Packaging","packaging-updated":"Packaging updated","failed-update-packaging":"Failed to update packaging","create-packaging":"Create Packaging","packaging-created":"Packaging created","failed-create-packaging":"Failed to create packaging","is-tube":"Is a tube?"}}')
  delete Component.options._Ctor
}
